import { useSWRConfig } from 'swr';

import { AddTrackingConnectionDialog } from './AddTrackingConnectionDialog';
import { isTelemetryConnectionsKey, type TelemetryParty } from '../models';

interface IConnectionsActionsProps {
  party?: TelemetryParty;
  /** An internal user owns no party, so they have to name each connection's owner themselves. */
  requiresOwner?: boolean;
  /** Whether this caller may change connections — a driver may only look. */
  canWrite?: boolean;
}

/**
 * The "add a tracking connection" action, for the title bar of whichever page shows a party's
 * connections. It opens the list of providers we support, so the action reads the same whether we offer
 * one connector or five. A driver may look but not write, and then this renders nothing.
 */
export const ConnectionsActions = ({ party, requiresOwner = false, canWrite = true }: IConnectionsActionsProps) => {
  // The list is revalidated through SWR itself rather than by subscribing to it: this component only
  // ever needs the revalidator, and subscribing would re-render the action on every revalidation.
  const { mutate } = useSWRConfig();

  if (!canWrite) {
    return null;
  }

  return (
    <AddTrackingConnectionDialog
      party={party}
      requiresOwner={requiresOwner}
      onSaved={() => mutate(isTelemetryConnectionsKey)}
    />
  );
};
